import getFlagCompleteState, { FlagCompleteEnum } from './helpers/getFlagCompleteState';
import setMailListRowsFlagState from './setMailListRowsFlagState';
import { isFeatureEnabled } from 'owa-feature-flags';
import { listViewStore, MailRowDataPropertyGetter, TableView } from 'owa-mail-list-store';
import { ActionSource } from 'owa-analytics-actions';
import FlagType from 'owa-service/lib/contract/FlagType';
import { action } from 'satcheljs/lib/legacy';

/**
 * Get the flag status to be set
 * @param rowKeys the conversation rowkeys
 * @param tableViewId the table view
 * @return the flag status to be set
 */
function getFlagStatusToSet(rowKeys: string[], tableView: TableView): FlagType {
    let flagType: FlagType;

    // Set the flag status to 'Flagged' if there is any non-flagged conversation
    for (let i = 0; i < rowKeys.length; i++) {
        const rowFlagStatus = MailRowDataPropertyGetter.getFlagStatus(rowKeys[i], tableView);
        switch (rowFlagStatus) {
            case 'Flagged':
                if (isFeatureEnabled('tri-flag-complete')) {
                    flagType = getFlagCompleteState(FlagCompleteEnum.complete);
                } else {
                    flagType = getFlagCompleteState(FlagCompleteEnum.clear);
                }
                break;
            case 'Complete':
            case 'NotFlagged':
            default:
                flagType = getFlagCompleteState(FlagCompleteEnum.noDate);
                break;
        }
    }
    return flagType;
}

/**
 * Toggle the given rows' flagged state
 * @param rowKeys the given rowkeys
 * @param tableViewId of the table that the row belong to
 */
export default action('toggleRowsFlagState')(function toggleRowsFlagState(
    rowKeys: string[],
    tableViewId: string,
    actionSource: ActionSource
) {
    const tableView = listViewStore.tableViews.get(tableViewId);
    const flagTypeToSet = getFlagStatusToSet(rowKeys, tableView);

    setMailListRowsFlagState(rowKeys, tableViewId, flagTypeToSet, actionSource);
});
